import React from 'react'
import styles from "./tnpsc-admissions.module.css";
import Link from 'next/link';

const About_TNPSC = () => {
 
  const thirdlist3 =[
    {list:"Our test series is a real simulation of the TNPSC Group I Prelims exam."},
    {list:"Our test series covers the syllabus holistically. "},
    {list:"Our test series is based on the dynamism of TNPSC"},
    {list:"All the tests will be conducted for 200 questions only"},
    {list:"We do post test discussion analysis on the perspective of difficulty level, conceptual level, Current Event level, etc.,"},
    {list:"Recorded post test discussion analysis will be provided for further reference."},
    {list:"Provides a platform for State Level Analysis of performance and improves your competency."},
    {list:"Flexible for working candidates to take the test as per their availability."}
  ]
   const thirdlist4 =[
    {list:"Free Interview classes."},
    {list:"Individual attention."},
    {list:"Mock Interview by serving bureaucrats and others."},
    {list:"Mock Interview will be recorded and analysis will be shared for further enhancement."}
  ]
  return (
    <>


    <div className='container'>
      <div className='row'>
        
      </div>
    </div>


    </>
  )
}

export default About_TNPSC;